<template>
  <div class="container">
    <div class="body" v-if="this.result == 'SUCCESS'">
      <van-row type="flex" justify="center" style="margin-top: 50px">
        <van-icon size="100" name="checked" color="green" />
      </van-row>
      <van-row class="mt-15" type="flex" justify="center">
        <span style="font-weight: bold; font-size: 25px">交易成功</span>
      </van-row>
      <van-row class="mt-15" gutter="10" type="flex" justify="center">
        <van-col span="6">商品名称</van-col>
        <van-col span="10">充值</van-col>
      </van-row>

      <van-row class="mt-15" gutter="10" type="flex" justify="center">
        <van-col span="6">商户订单号</van-col>
        <van-col span="10">TAJS5293845345345</van-col>
      </van-row>

      <van-row class="mt-15" gutter="10" type="flex" justify="center">
        <van-col span="6">收款商户</van-col>
        <van-col span="10">天安（贵州省）互联网金融资产交易中心-新</van-col>
      </van-row>

      <van-row class="mt-15" gutter="10" type="flex" justify="center">
        <van-col span="6">交易金额</van-col>
        <van-col span="10">10元</van-col>
      </van-row>

      <van-row type="flex" justify="center" class="mt-15">
        <van-button
          @click="callbackPayResult"
          plain
          hairline
          style="width: 80%; height: 50px; color: green">
          返回商户（{{ backTime + "s" }}）
        </van-button>
      </van-row>
    </div>
    <div class="body" v-else-if="this.result == 'FAILURE'">
      <van-row type="flex" justify="center" style="margin-top: 50px">
        <van-icon size="100" name="clear" color="red" />
      </van-row>
      <van-row class="mt-15" type="flex" justify="center">
        <span style="font-weight: bold; font-size: 25px">交易失败</span>
      </van-row>
      <van-row type="flex" justify="center" class="mt-15">
        <van-button
          @click="callbackPayResult"
          plain
          hairline
          style="width: 80%; height: 50px; color: green">
          返回商户（{{ backTime + "s" }}）
        </van-button>
      </van-row>
    </div>
    <div class="body" v-else-if="this.result == 'PROCESSING'">
      <van-row type="flex" justify="center" style="margin-top: 50px">
        <van-icon size="100" name="underway" color="green" />
      </van-row>
      <van-row class="mt-15" type="flex" justify="center">
        <span style="font-weight: bold; font-size: 25px">交易处理中</span>
      </van-row>
      <van-row type="flex" justify="center" class="mt-15">
        <van-button
          @click="callbackPayResult"
          plain
          hairline
          style="width: 80%; height: 50px; color: green">
          返回商户（{{ backTime + "s" }}）
        </van-button>
      </van-row>
    </div>
    <div class="footer">
      <span class="corlor:gray">连连银通电子支付有限公司版权所有</span>
    </div>
  </div>
</template>

<script>
import qs from "qs"
import axios from "axios"
import { Row, Icon, Col, Button } from "vant"

const http = axios.create()
export default {
  name: "MockPaymentResult",
  components: {
    [Row.name]: Row,
    [Button.name]: Button,
    [Col.name]: Col,
    [Icon.name]: Icon
  },
  data() {
    return {
      backTime: 5,
      result: "",
      backUrl: "",
      notifyUrl: "",
      orderNo: "",
      result: ""
    }
  },
  created() {
    this.backUrl = this.$route.query.backUrl
    console.log("返回URL", this.backUrl)
    this.notifyUrl = this.$route.query.notifyUrl
    console.log("通知URL", this.notifyUrl)
    this.orderNo = this.$route.query.orderNo
    console.log("订单号", this.orderNo)
    this.result = this.$route.query.result
    console.log("订单结果", this.result)
  },
  methods: {
    callbackPayResult() {
      //如果成功调用回调方法
      const data = {
        orderNo: this.orderNo,
        result: this.result
      }
      if (this.result == "SUCCESS") {
        http({
          url: this.notifyUrl,
          method: "POST",
          headers: { "content-type": "application/x-www-form-urlencoded" },
          data: qs.stringify(data)
        })
          .then(() => {
            this._showToast("异步通知成功")
            this.redirect(data)
          })
          .catch((err) => {
            console.log(err)
            this._showToast("异步通知失败")
            this.redirect(data)
          })
      } else {
        this._showToast("订单失败屏蔽异步通知")
        this.redirect(data)
      }
    },

    redirect(data) {
      //如果处理中和失败则返回商户首页
      http({
        url: this.backUrl,
        method: "POST",
        headers: { "content-type": "application/x-www-form-urlencoded" },
        data: qs.stringify(data)
      })
        .then((response) => {
          console.log("重定向到" + response.data.data)
          window.location.href = response.data.data
          this._showToast("异步重定向成功")
        })
        .catch((err) => {
          console.log(err)
          this._showToast("异步重定向失败")
        })
    }
  }
}
</script>

<style lang="less">
.container {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;

  .footer {
    width: 100%;
    height: 60px;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 30px;
    left: 0;
    border-top: solid 0.5px rgb(210, 207, 207);
  }
}
</style>